<div class="d-flex login">
    <div class="w-50">
        <div class="d-flex flex-column">
            <div class="mt-5 mx-2 text-center">
                <img src="https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/Focus-With-Cloud-New-Trans.png" style="width: 100%; height: auto;" alt="Focus Cloud">
            </div>
            <div class="m-2 text-lowercase p-text-justify">
                Say goodbye to workarounds and disjointed operations. Focus POS restaurant management systems turn workflows into
                simple, streamlined processes. Focus POS empowers you to control labor costs, efficiently manage inventory, and have
                deeper visibility into your business.
            </div>
            <div class="login-image">
                <img src="https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/cc-login-restaurant-staff.png" style="width: 100%; height: auto;">
            </div>
        </div>
    </div>
    
    <div class="w-50">
    
    </div>

</div>